webpackJsonp([114276838955818,60335399758886],{

/***/ 107:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(219);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(107);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "contact" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                    "form",
	                    { name: "contact", method: "post", "data-netlify": "true", "data-netlify-honeypot": "bot-field" },
	                    _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "contact" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half first" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "name" },
	                            "Name"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "name", id: "name" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field half" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "email" },
	                            "Email"
	                        ),
	                        _react2.default.createElement("input", { type: "text", name: "email", id: "email" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "field" },
	                        _react2.default.createElement(
	                            "label",
	                            { htmlFor: "message" },
	                            "Message"
	                        ),
	                        _react2.default.createElement("textarea", { name: "message", id: "message", rows: "6" })
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "actions" },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "submit", value: "Send Message", className: "special" })
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement("input", { type: "reset", value: "Clear" })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { className: "split" },
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-envelope" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Email"
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { href: "mailto:brianc@palaver.net?Subject=Email from Sunny Crest", target: "_blank" },
	                            "brianc@palaver.net"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-phone" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Phone"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "(219) 253-8181"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "contact-method" },
	                        _react2.default.createElement("span", { className: "icon alt fa-home" }),
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            "Map Search Address"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "8806 N. SR 71",
	                            _react2.default.createElement("br", null),
	                            "Earl Park, Indiana 47942",
	                            _react2.default.createElement("br", null),
	                            "USA"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        "footer",
	        { id: "footer" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "ul",
	                { className: "icons" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "https://github.com/capouch/sunnycrest", className: "icon alt fa-github" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "GitHub"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: "copyright" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "\xA9 Brian Capouch"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Based on design by: ",
	                    _react2.default.createElement(
	                        "a",
	                        { href: "https://html5up.net" },
	                        "HTML5 UP"
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', className: 'alt' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'logo' },
	            _react2.default.createElement(
	                'strong',
	                null,
	                'Portteus Farm'
	            ),
	            ' ',
	            _react2.default.createElement(
	                'span',
	                null,
	                'Brian Capouch'
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'menu-link', onClick: props.onToggleMenu, href: 'javascript:;' },
	                'Menu'
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	    return _react2.default.createElement(
	        'nav',
	        { id: 'menu' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'links' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/' },
	                        'Home'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/contact' },
	                        'Contact'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/arch' },
	                        'Architecture'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/mission' },
	                        'Mission'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/notify' },
	                        'Notifications'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'close', onClick: props.onToggleMenu, href: 'javascript:;' },
	            'Close'
	        )
	    );
	};
	
	Menu.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(14);
	
	__webpack_require__(425);
	
	var _Header = __webpack_require__(216);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(217);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Contact = __webpack_require__(80);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Footer = __webpack_require__(215);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	    _inherits(Template, _React$Component);
	
	    function Template(props) {
	        _classCallCheck(this, Template);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            isMenuVisible: false,
	            loading: 'is-loading'
	        };
	        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	        return _this;
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.timeoutId = setTimeout(function () {
	            _this2.setState({ loading: '' });
	        }, 100);
	        // Still looking for the right place for this
	        // This ain't it, for sure
	        Notification.requestPermission(function (status) {
	            var permStatus = status;
	            console.log('Notification permission status:', status);
	        });
	    };
	
	    Template.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	
	    Template.prototype.handleToggleMenu = function handleToggleMenu() {
	        this.setState({
	            isMenuVisible: !this.state.isMenuVisible
	        });
	    };
	
	    Template.prototype.render = function render() {
	        var children = this.props.children;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('link', { rel: 'stylesheet', href: (0, _gatsbyLink.withPrefix)('skel.css') })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'wrapper' },
	                _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	                children(),
	                _react2.default.createElement(_Footer2.default, null)
	            ),
	            _react2.default.createElement(_Menu2.default, { onToggleMenu: this.handleToggleMenu })
	        );
	    };
	
	    return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	    children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-7d91e881c770dde6b3fe.js